module.exports = __webpack_public_path__ + "static/img/model-collect.775f8bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/model-collect.png
// module id = fWA7
// module chunks = 36